module.exports = __webpack_public_path__ + "img/instagram.01073bda.svg";